import { fetchProfile } from "@api/moimAPI";
import {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { LOCAL_STORAGE_KEYS } from "../constant/keys";

interface IContext {
  currentUser: Moim.User.IOriginalUserDatum | null;
  setCurrentUser?: (user: Partial<Moim.User.IOriginalUserDatum>) => void;
}

const CurrentUserContext = createContext<IContext>({
  currentUser: null,
});

export const CurrentUserProvider = ({ children }) => {
  const [currentUser, setCurrentUser] =
    useState<Moim.User.IOriginalUserDatum | null>(null);

  const updateCurrentUserState = useCallback(
    (user: Partial<Moim.User.IOriginalUserDatum>) => {
      setCurrentUser(prev => {
        const newUser = {
          ...prev,
          ...user,
        };

        localStorage.setItem(
          LOCAL_STORAGE_KEYS.SIGNED_USER,
          JSON.stringify(newUser),
        );
        return newUser;
      });
    },
    [],
  );

  const asyncFetchCurrentUser = useCallback(async () => {
    const authToken = localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN);
    if (authToken) {
      try {
        const response = await fetchProfile();
        updateCurrentUserState(response);
      } catch (err) {
        console.error(err);
      }
    }
  }, []);

  useEffect(() => {
    const user = localStorage.getItem(LOCAL_STORAGE_KEYS.SIGNED_USER);
    if (user) {
      setCurrentUser(JSON.parse(user));
      asyncFetchCurrentUser();
    }
  }, []);

  return (
    <CurrentUserContext.Provider
      value={{ currentUser, setCurrentUser: updateCurrentUserState }}
    >
      {children}
    </CurrentUserContext.Provider>
  );
};

export const useCurrentUser = () => {
  return useContext(CurrentUserContext);
};
